<template>
  <div class="ComparedRecommendationsOfExpert">
    <el-row>
      <el-col :xs="24" :sm="24" :md="24" :lg="24" :xl="24" v-for="(reco_data, index) in expertsRecommendationsList" :key="index" class="top-margin-25">
        <div style="display: flex; justify-content: space-between;">
          <div class="cursor-pointer" @click="getRecoByStockName()">
            <span class="stock-title">{{ reco_data.stock.name }}</span>
            &nbsp;
            <span class="code-title" v-if="reco_data.stock.symbol">({{ reco_data.stock.symbol }})</span>
            <!-- &nbsp;
            <img v-if="reco_data.source == 'marketplace'" src="../assets/images/loudspeaker1.svg" width="22" height="22" style="vertical-align: middle;"> -->
          </div>
          <span class="cross-icon" v-on:click="removeFromList(index)" title="Remove">&#x2715;</span>
        </div>

              <!-- stock details section -->
        <div class="border-bottom-gray top-margin-5">
          <el-row>
            <el-col :xs="24" :sm="24" :md="6" :lg="6" :xl="6" class="margin-right-20">
              <span class="estimate-value right-margin-10" title="Current price">
                ₹ {{ reco_data.stock.current_price }}
              </span>
              <span style="margin-top:10px;" class="stock-section-inc" :style="[ reco_data.stock.price_difference >= 0 ? { color: '#079e3e' } : { color: '#d60918' } ]">
                <span style="font-size: 18px;" v-if="reco_data.stock.price_difference >= 0">&#9652;</span>
                <span style="font-size: 18px;" v-else>&#9662;</span>
                {{ reco_data.stock.price_difference }} ({{ reco_data.stock.potential_difference }}%)
              </span>

              <div class="input-label-gray" style="font-size: 10px;" v-if="reco_data.stock.current_datetime">
                {{ reco_data.stock.current_datetime | stock_live_price_date_filter }}
              </div>
            </el-col>

            <el-col :xs="24" :sm="24" :md="9" :lg="9" :xl="9" class="top-margin-10">
              <el-tag
                size="mini"
                class="right-margin-10 sector-tag"
                effect="plain"
                title="Market size"
                type="info"
                v-if="reco_data.stock.market_cap">
                {{ reco_data.stock.market_cap }}
              </el-tag>

              <el-tag
                size="mini"
                class="right-margin-10 sector-tag"
                effect="plain"
                title="Sector"
                type="info"
                v-if="reco_data.stock.sector">
                {{ reco_data.stock.sector }}
              </el-tag>
            </el-col>
          </el-row>
        </div>

        <el-row class="top-margin-15 reco-details">
          <el-col :xs="24" :sm="24" :md="12" :lg="12" :xl="12">
            <el-row>
              <el-col :xs="24" :sm="24" :md="24" :lg="12" :xl="12">
                <div style="display: flex;">
                  <img v-if="!reco_data.user.pic" src="../assets/images/navBar/avatar.jpg" class="user-profile-pic" alt/>

                  <img v-else :src="serverHostName + reco_data.user.pic"
                  class="user-profile-pic" alt/>

                  <div class="company-employee-details">
                    <div class="label-lg-black-bold right-margin-3" :style="[($router.currentRoute.path == '/experts-past-recommendations') ? { 'cursor' : 'pointer'} : { 'cursor' : 'text'}]" @click="getRecoByExpert(reco_data)" style="text-transform: capitalize;">
                    {{ reco_data.user.full_name }}
                    </div>

                    <span>
                      <span class="right-margin-3 input-label-gray" v-if="reco_data.user.company && reco_data.user.profession != 'Student'">{{ reco_data.user.company.name }} - </span>

                      <span class="right-margin-3 input-label-gray" v-if="reco_data.user.institute_name && reco_data.user.profession == 'Student'">{{ reco_data.user.institute_name }} - </span>

                      <span class="right-margin-3 input-label-gray">{{ reco_data.user.profession }}</span>
                    </span>

                    <img v-if="reco_data.source == 'marketplace'" src="../assets/images/loudspeaker1.svg" width="17" height="17" title="Public recommendation" style="vertical-align: middle; margin-left: 5px;">
                    <br />

                    <span class="right-margin-3 input-label-gray">
                      Total Recommendation -
                      <span class="input-label-bold-gray">{{ reco_data.user.total_reco ? reco_data.user.total_reco : 0 }}</span>
                    </span>
                  </div>
                </div>
              </el-col>

              <el-col :xs="24" :sm="24" :md="24" :lg="4" :xl="4" class="reco-section">
                <div>
                  <div class="input-label-bold-gray" style="margin-top: 0;">Reco</div>
                  <div class="reco-btn-section">
                      <el-tag
                        class="reco-btns"
                        size="mini"
                        value="Buy"
                        :class="[reco_data.reco == 'Buy' ? 'active-period-type-tag' : 'period-type-tag']"
                      >Buy</el-tag>
                      <el-tag
                        class="reco-btns"
                        size="mini"
                        value="Sell"
                        :class="[reco_data.reco == 'Sell' ? 'active-period-type-tag-red': 'period-type-tag']"
                      >Sell</el-tag>
                      <el-tag
                        class="reco-btns"
                        size="mini"
                        value="Hold"
                        :class="[reco_data.reco == 'Hold' ? 'active-period-type-tag-yellow': 'period-type-tag']"
                      >Hold</el-tag>
                  </div>
                </div>
              </el-col>

              <el-col :xs="24" :sm="24" :md="24" :lg="8" :xl="8" class="target-period-section">
                <div class="target-period-details">
                  <div class="period-contents">
                    <label class="input-label-bold-gray">Target Period</label>
                    <!-- <div class="bottom-margin-10 label-xs-bold">{{reco_data.target_period.slice(5)}}</div> -->
                    <div class="bottom-margin-10 label-xs-bold">{{ reco_data.target_period }}</div>
                  </div>

                  <div class="period-contents">
                    <label class="input-label-bold-gray">Target Price</label>
                    <div class="bottom-margin-10 label-xs-bold">
                      ₹ {{ reco_data.target_price }}
                      <span
                      class="input-label-bold-gray"
                      >({{ reco_data.target_potential }}%)</span>
                    </div>
                  </div>

                  <div class="period-contents" v-if="reco_data.stop_loss">
                    <label class="input-label-bold-gray">Stop Loss</label>
                    <div class="bottom-margin-10 label-xs-bold">
                      ₹ {{ reco_data.stop_loss }}
                      <span class="input-label-bold-gray">({{ reco_data.stop_loss_potential }}%)</span>
                    </div>
                  </div>

                  <div class="period-contents">
                    <div>
                      <label class="input-label-bold-gray">
                        Antestimate
                        <el-popover
                          placement="bottom"
                          title="Antestimate"
                          width="225"
                          trigger="click"
                          content="Aggregated price estimates of users (only for short term)">
                          <img
                            class="info-Logo cursor-pointer"
                            src="../assets/images/company/info-button.svg"
                            alt
                          slot="reference" />
                        </el-popover>
                      </label>
                      <div class="bottom-margin-10 label-xs-bold" v-if="reco_data.antestimate_number && reco_data.reco_status != 'CLOSED'">
                        {{ reco_data.antestimate_number }}
                      </div>
                      <div class="bottom-margin-10 label-xs-bold" v-else>
                        No data available
                      </div>
                    </div>

                    <!-- <div v-if="recoType == 'longTerm'">&nbsp;</div> -->
                  </div>
                </div>
              </el-col>
            </el-row>
            <div class="faded-border-bottom target-period-section-border">&nbsp;</div>
          </el-col>

          <el-col :xs="24" :sm="24" :md="12" :lg="12" :xl="12">
            <el-row class="performance-accuracy-container">
              <el-col :xs="12" :sm="12" :md="14" :lg="15" :xl="15">
                <div class="performance-section">
                  <el-tooltip
                    class="item"
                    effect="dark"
                    :disabled="reco_data.reco_status == 'YET TO LIVE'"
                    :content="reco_data.reco_status == 'TARGET ACHIEVED' ? 100 + '%' : reco_data.performance + '%'"
                    placement="top">
                    <NewCircleProgress
                      :transitionDuration="5000"
                      :radius="44"
                      :strokeWidth="10"
                      :strokeColor="((reco_data.reco_status == 'LIVE' || reco_data.reco_status == 'UPDATED' || reco_data.reco_status == 'CLOSED' || reco_data.reco_status == 'STOP LOSS TRIGGERED' || reco_data.reco_status == 'TARGET NOT ACHIEVED') && reco_data.performance > 0) ? '#079e3e' : (reco_data.reco_status == 'LIVE' || reco_data.reco_status == 'UPDATED' || reco_data.reco_status == 'CLOSED' || reco_data.reco_status == 'STOP LOSS TRIGGERED' || reco_data.reco_status == 'TARGET NOT ACHIEVED') && reco_data.performance < 0 ? '#d60918' : '#079e3e'"
                      :value="getPerformanceWheelValue(reco_data) > 100 ? 100 : getPerformanceWheelValue(reco_data)"
                    >
                      <div class style="font-size: 0.6rem;">{{ reco_data.reco_status }}</div>
                      <template v-slot:footer></template>
                    </NewCircleProgress>
                  </el-tooltip>

                  <div class="progress-description">
                    <div class="input-label-xs-bold-black">
                      <!-- if reco status is closed then displayed closed date to stop date calculation -->
                      <span v-if="reco_data.reco_status == 'CLOSED'">
                        As on {{ reco_data.closed_date_time | formatDate }}
                      </span>

                      <!-- if reco status is target achieved then displayed achieved date to stop date calculation -->
                      <span v-if="reco_data.reco_status == 'TARGET ACHIEVED'">
                        As on {{ reco_data.target_achieved_date_time | formatDate }}
                      </span>

                      <!-- if reco status is target not achieved then displayed result_date_time to stop date calculation -->
                      <span v-if="reco_data.reco_status == 'TARGET NOT ACHIEVED'">
                        As on {{ reco_data.target_not_achieved_date_time | formatDate }}
                      </span>

                      <span v-if="reco_data.reco_status == 'STOP LOSS TRIGGERED'">
                        As on {{ reco_data.stop_loss_triggered_date_time | formatDate }}
                      </span>

                      <!--if only reco status is live, yet to live and updated -->
                      <span v-if="reco_data.reco_status == 'LIVE' || reco_data.reco_status == 'YET TO LIVE' || reco_data.reco_status == 'UPDATED'">
                        As on {{ reco_data.stock.today | formatDate }}
                      </span>

                      <!-- reco duration section -->
                      <!-- if reco status is live, yet to live, stop loss triggered and current date is reco date then displayed -->
                      <div class="input-label-xs-bold-black top-margin-5" v-if="(reco_data.reco_status == 'LIVE' || reco_data.reco_status == 'YET TO LIVE' || reco_data.reco_status == 'STOP LOSS TRIGGERED') && reco_data.difference_in_days == 0">
                        (Today)
                      </div>

                      <!-- if only reco status is live, yet to live, stop loss triggered, target achieved, target not achieved and current date is greater than reco date -->
                      <div class="input-label-xs-bold-black top-margin-5" v-if="(reco_data.reco_status == 'LIVE' || reco_data.reco_status == 'YET TO LIVE' || reco_data.reco_status == 'STOP LOSS TRIGGERED' || reco_data.reco_status == 'TARGET ACHIEVED' || reco_data.reco_status == 'TARGET NOT ACHIEVED') && reco_data.difference_in_days != 0">
                        ({{ reco_data.difference_in_days }}
                        <span v-if="reco_data.difference_in_days > 1">Days</span>
                        <span v-else>Day</span> from reco date)
                      </div>

                      <!-- if reco status is updated and current date is reco date then displayed -->
                      <div class="input-label-xs-bold-black top-margin-5" v-if="reco_data.reco_status == 'UPDATED' && reco_data.difference_in_days == 0">
                        (Updated Today)
                      </div>

                      <!-- if reco status is updated and current date is greater than reco date -->
                      <div class="input-label-xs-bold-black top-margin-5" v-if="reco_data.reco_status == 'UPDATED' && reco_data.difference_in_days != 0">
                        ({{ reco_data.difference_in_days }}
                        <span v-if="reco_data.difference_in_days > 1">Days</span>
                        <span v-else>Day</span> from updated reco date)
                      </div>

                      <!-- if reco status is target achieved, target not achieved on same day (reco published day) then displayed -->
                      <div class="input-label-xs-bold-black top-margin-5" v-if="(reco_data.reco_status == 'TARGET ACHIEVED' || reco_data.reco_status == 'TARGET NOT ACHIEVED') && reco_data.difference_in_days == 0">
                        (On Reco date)
                      </div>

                      <!-- if recos closed or target achieved on updated reco day then displayed -->
                      <div class="input-label-xs-bold-black top-margin-5" v-if="reco_data.has_close_reco && reco_data.difference_in_days == 0 && (reco_data.reco_status == 'TARGET ACHIEVED')">
                        (On Updated Reco date)
                      </div>

                      <div class="progress-bar-legends-section top-margin-20">
                        <div class="flex">
                          <div class="progress-bar-legends"
                            :style="[((reco_data.reco_status == 'LIVE' || reco_data.reco_status == 'UPDATED' || reco_data.reco_status == 'CLOSED' || reco_data.reco_status == 'STOP LOSS TRIGGERED' || reco_data.reco_status == 'TARGET NOT ACHIEVED') && reco_data.performance > 0) ? {'background-color': '#079e3e'} : (reco_data.reco_status == 'LIVE' || reco_data.reco_status == 'UPDATED' || reco_data.reco_status == 'CLOSED' || reco_data.reco_status == 'STOP LOSS TRIGGERED' || reco_data.reco_status == 'TARGET NOT ACHIEVED') && reco_data.performance < 0 ? {'background-color': '#d60918'} : reco_data.reco_status == 'TARGET ACHIEVED' ? {'background-color': '#079e3e'} : {'background-color': '#a29eab'} ]">
                            &nbsp;
                          </div>
                          <div class="legends-text">Performance</div>
                        </div>
                        <div class="flex top-margin-5">
                          <div class="progress-bar-legends">&nbsp;</div>
                          <div class="legends-text">Potential</div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </el-col>

              <el-col :xs="12" :sm="12" :md="10" :lg="9" :xl="9">
                <div class="accuracy-section">
                  <div class="label-md-gray">
                    Accuracy
                    <el-popover
                      placement="bottom"
                      title="Accuracy"
                      width="200"
                      trigger="click"
                      content="Target price compared with actu-al price result">

                      <img class="info-Logo cursor-pointer" src="../assets/images/company/info-button.svg" alt
                      slot="reference" />
                    </el-popover>
                  </div>

                  <div class="timer top-margin-5">
                    <Timer
                      v-if="(reco_data.stock.today != null && reco_data.result_date_time != null) && (reco_data.stock.today != '' && reco_data.result_date_time != '' && (reco_data.accuracy === '' || reco_data.accuracy === null) && reco_data.reco_status != 'CLOSED')"
                      :starttime="reco_data.stock.today"
                      :endtime="reco_data.result_date_time"
                      :trans='{
                        day: "day",
                        hours: "Hours",
                        minutes: "Minuts",
                      }'
                    ></Timer>
                  </div>

                  <div v-if="reco_data.result_date_time != null && reco_data.result_date_time != '' && (reco_data.accuracy === '' || reco_data.accuracy === null) && reco_data.reco_status != 'CLOSED'">
                    <label class="input-label-gray">(Result Date: {{ reco_data.result_date_time | formatDate }})
                    </label>
                  </div>

                  <div class="input-label-xs-bold-black cursor-pointer" style="font-size: 28px;" v-if="reco_data.reco_status != 'CLOSED' && reco_data.accuracy !== '' && reco_data.accuracy !== null" >
                    <!-- @click="goToResultPage(reco_data)" -->
                    {{ reco_data.accuracy }}%
                  </div>

                  <div class="antestimate-block" v-if="reco_data.reco_status != 'CLOSED' && reco_data.accuracy !== '' && reco_data.accuracy !== null">
                    Antestimate : {{ reco_data.antestimate_accuracy ? reco_data.antestimate_accuracy.toFixed(2) +'%' : 'No data' }}
                  </div>

                  <div class="input-label-xs-bold-black" style="font-size: 1.1rem;" v-if="reco_data.reco_status == 'CLOSED' && reco_data.accuracy === ''">
                    Reco is closed
                  </div>
                </div>
              </el-col>
            </el-row>
          </el-col>
        </el-row>

        <!-- toogle more info section -->
        <div class="flex flex-center">
          <span
            class="input-label-gray cursor-pointer"
            style="margin: 10px 0px;"
            icon
            @click="toggleMoreInfo(index)"
            v-if="reco_data.toggle_more_info"
            >
            Less details
            <i class="el-icon-arrow-up"></i>
          </span>

          <span
            class="input-label-gray cursor-pointer"
            style="margin: 10px 0px; text-transform: capitalize;"
            icon
            @click="toggleMoreInfo(index)"
            v-else
            >
            {{ reco_data.user.first_name }}'s reco details
            <!-- More information -->
            <i class="el-icon-arrow-down"></i>
          </span>
        </div>

        <div class="faded-border-bottom">&nbsp;</div>

        <!-- reco full description -->
        <el-row :gutter="20" class="top-margin-20" v-if="reco_data.toggle_more_info">
          <el-col :xs="24" :sm="24" :md="9" :lg="9" :xl="7">
            <div class="antistimate-button">
                <!-- @click="goToAntestimateLink(reco_data)" -->
              <el-button
                type="primary"
                v-if="reco_data.antestimate_number && reco_data.reco_status != 'CLOSED'"
              >
                Antestimate: {{ reco_data.antestimate_number }}
                <i class="el-icon-arrow-right"></i>
              </el-button>
              <el-button v-else type="default" disabled>Antestimate: No data available</el-button>
            </div>
          </el-col>

          <el-col :xs="24" :sm="24" :md="15" :lg="15" :xl="16">
            <div class="reco-more-details-container isDeskTopView">
              <div>
                <div>
                  <label class="input-label-gray">
                    Reco Date
                    <el-popover
                      placement="bottom"
                      title="Reco date"
                      width="225"
                      trigger="click"
                      content="Date of recommendation">
                      <img
                        class="info-Logo cursor-pointer"
                        src="../assets/images/company/info-button.svg"
                        alt
                      slot="reference" />
                    </el-popover>
                  </label>
                  <div class="label-xs-bold">{{ reco_data.created_at  | formatDate }}</div>
                </div>

                <div class="top-margin-10">
                  <label class="input-label-gray">
                    Reco Price
                    <el-popover
                      placement="bottom"
                      title="Reco price"
                      width="225"
                      trigger="click"
                      content="Price on date of recommendation">
                      <img
                        class="info-Logo cursor-pointer"
                        src="../assets/images/company/info-button.svg"
                        alt
                      slot="reference" />
                    </el-popover>
                  </label>
                  <div class="label-xs-bold">₹ {{ reco_data.reco_open_price }}</div>
                </div>
              </div>

              <div class="vertical-flex">
                <label class="input-label-gray">
                  Performance
                  <el-popover
                    placement="bottom"
                    title="Performance"
                    width="225"
                    trigger="click"
                    content="% return achieved from recommendation (price on date of recommendation and price as of now)">
                    <img
                      class="info-Logo cursor-pointer"
                      src="../assets/images/company/info-button.svg"
                      alt
                    slot="reference" />
                  </el-popover>
                </label>
                <span
                  class="label-lg-bold"
                  :style="[ ((reco_data.reco_status == 'LIVE' || reco_data.reco_status == 'UPDATED' || reco_data.reco_status == 'CLOSED' || reco_data.reco_status == 'STOP LOSS TRIGGERED' || reco_data.reco_status == 'TARGET NOT ACHIEVED') && reco_data.performance > 0) ? {'color': '#079e3e'} : (reco_data.reco_status == 'LIVE' || reco_data.reco_status == 'UPDATED' || reco_data.reco_status == 'CLOSED' || reco_data.reco_status == 'STOP LOSS TRIGGERED' || reco_data.reco_status == 'TARGET NOT ACHIEVED') && reco_data.performance < 0 ? {'color': '#d60918'} : reco_data.reco_status == 'TARGET ACHIEVED' ? {'color': '#079e3e'} : {'color': '#a29eab'} ]"
                >{{ !reco_data.performance ? 0 :reco_data.performance }}%</span>
              </div>

              <div>
                <div>
                  <label class="input-label-gray">Last Tracked Date</label>
                  <div class="label-xs-bold">{{ reco_data.reco_status == 'CLOSED' ? reco_data.closed_date_time : reco_data.reco_status == 'STOP LOSS TRIGGERED' ? reco_data.stop_loss_triggered_date_time :
                  reco_data.reco_status == 'TARGET ACHIEVED' ? reco_data.target_achieved_date_time : reco_data.reco_status == 'TARGET NOT ACHIEVED' ? reco_data.target_not_achieved_date_time : reco_data.stock.today | formatDate }}
                  </div>
                </div>

                <div class="top-margin-10">
                  <label class="input-label-gray">Last Tracked Price</label>
                  <div class="label-xs-bold">₹ {{ reco_data.reco_status == 'CLOSED' ? reco_data.closed_price : reco_data.reco_status == 'STOP LOSS TRIGGERED' ? reco_data.stop_loss_triggered_price :
                  reco_data.reco_status == 'TARGET ACHIEVED' ? reco_data.target_achieved_price : reco_data.reco_status == 'TARGET NOT ACHIEVED' ? reco_data.target_not_achieved_price : reco_data.stock.current_price }}</div>
                  <!-- <div class="label-xs-bold">₹ {{ reco_data.stock.current_price }}</div> -->
                </div>
              </div>

              <div class="vertical-flex">
                <label class="input-label-gray">
                  Potential
                  <el-popover
                    placement="bottom"
                    title="Potential"
                    width="225"
                    trigger="click"
                    content="% return expected from recommendation (price as of now and target price)">
                    <img
                      class="info-Logo cursor-pointer"
                      src="../assets/images/company/info-button.svg"
                      alt
                    slot="reference" />
                  </el-popover>
                </label>
                <div class="label-lg-bold" style="color: #979797;">{{ !reco_data.potential_as_of_cdate ? 0 : reco_data.potential_as_of_cdate }}%</div>
              </div>

              <div>
                <div>
                  <label class="input-label-gray">Target Period</label>
                  <div class="label-xs-bold">{{ reco_data.target_period }}</div>
                </div>
                <div class="top-margin-10">
                  <label class="input-label-gray">Target Price</label>
                  <div class="label-xs-bold">
                    ₹ {{ reco_data.target_price }}
                    <span class="input-label-gray" style="font-size: 11px;">({{ reco_data.target_potential }}%)</span>
                  </div>
                </div>
              </div>
            </div>

            <div class="reco-more-details-container isMobileView">
              <div class="col1" style="display: flex;">
                <div class="row1">
                  <div>
                    <label class="input-label-gray">
                      Reco Date
                      <el-popover
                        placement="bottom"
                        title="Reco date"
                        width="225"
                        trigger="click"
                        content="Date of recommendation">
                        <img
                          class="info-Logo cursor-pointer"
                          src="../assets/images/company/info-button.svg"
                          alt
                        slot="reference" />
                      </el-popover>
                    </label>
                    <div class="bottom-margin-10 label-xs-bold">{{ reco_data.created_at | formatDate }}</div>
                  </div>

                  <div>
                    <label class="input-label-gray">Last Tracked Date</label>
                    <div class="bottom-margin-10 label-xs-bold">{{ reco_data.reco_status == 'CLOSED' ? reco_data.closed_date_time : reco_data.reco_status == 'STOP LOSS TRIGGERED' ? reco_data.stop_loss_triggered_date_time :
                      reco_data.reco_status == 'TARGET ACHIEVED' ? reco_data.target_achieved_date_time : reco_data.reco_status == 'TARGET NOT ACHIEVED' ? reco_data.target_not_achieved_date_time :  reco_data.stock.today | formatDate }}
                    </div>
                  </div>

                  <div>
                    <label class="input-label-gray">Target Period</label>
                    <div class="bottom-margin-10 label-xs-bold">{{ reco_data.target_period }}</div>
                  </div>
                </div>
              </div>

              <div class="col2">
                <div class="row2">
                  <div>
                    <label class="input-label-gray">
                      Reco Price
                      <el-popover
                        placement="bottom"
                        title="Reco price"
                        width="225"
                        trigger="click"
                        content="Price on date of recommendation">
                        <img
                          class="info-Logo cursor-pointer"
                          src="../assets/images/company/info-button.svg"
                          alt
                        slot="reference" />
                      </el-popover>
                    </label>
                    <div class="bottom-margin-10 label-xs-bold">₹ {{ reco_data.reco_open_price }}</div>
                  </div>

                  <div>
                    <label class="input-label-gray">Last Tracked Price</label>
                    <div class="bottom-margin-10 label-xs-bold">
                      ₹ {{ reco_data.reco_status == 'CLOSED' ? reco_data.closed_price : reco_data.reco_status == 'STOP LOSS TRIGGERED' ? reco_data.stop_loss_triggered_price : reco_data.reco_status == 'TARGET ACHIEVED' ? reco_data.target_achieved_price : reco_data.reco_status == 'TARGET NOT ACHIEVED' ? reco_data.target_not_achieved_price : reco_data.stock.current_price }}</div>
                  </div>

                  <div>
                    <label class="input-label-gray">Target Price</label>
                    <div class="bottom-margin-10 label-xs-bold">
                      ₹ {{ reco_data.target_price }}
                      <span class="input-label-gray" style="font-size: 11px;">({{ reco_data.target_potential }}%)</span>
                    </div>
                  </div>
                </div>
              </div>

              <div class="col3 vertical-flex">
                <label class="input-label-gray">
                  Performance
                  <el-popover
                    placement="bottom"
                    title="Performance"
                    width="225"
                    trigger="click"
                    content="% return achieved from recommendation (price on date of recommendation and price as of now)">
                    <img
                      class="info-Logo cursor-pointer"
                      src="../assets/images/company/info-button.svg"
                      alt
                    slot="reference" />
                  </el-popover>
                </label>
                <div
                  class="label-lg-bold"
                  :style="[ ((reco_data.reco_status == 'LIVE' || reco_data.reco_status == 'UPDATED' || reco_data.reco_status == 'CLOSED' || reco_data.reco_status == 'STOP LOSS TRIGGERED' || reco_data.reco_status == 'TARGET NOT ACHIEVED') && reco_data.performance > 0) ? {'color': '#079e3e'} : (reco_data.reco_status == 'LIVE' || reco_data.reco_status == 'UPDATED' || reco_data.reco_status == 'CLOSED' || reco_data.reco_status == 'STOP LOSS TRIGGERED' || reco_data.reco_status == 'TARGET NOT ACHIEVED') && reco_data.performance < 0 ? {'color': '#d60918'} : reco_data.reco_status == 'TARGET ACHIEVED' ? {'color': '#079e3e'} : {'color': '#a29eab'} ]"
                >{{ !reco_data.performance ? 0 : reco_data.performance }}%</div>

                <label class="input-label-gray">
                  Potential
                  <el-popover
                    placement="bottom"
                    title="Potential"
                    width="225"
                    trigger="click"
                    content="% return expected from recommendation (price as of now and target price)">
                    <img
                      class="info-Logo cursor-pointer"
                      src="../assets/images/company/info-button.svg"
                      alt
                    slot="reference" />
                  </el-popover>
                </label>
                <div class="label-lg-bold" style="color: #979797;">{{ reco_data.potential_as_of_cdate ==null ? 0 : reco_data.potential_as_of_cdate }}%
                </div>
              </div>
            </div>
          </el-col>
        </el-row>

        <!-- previous closed reco section -->
        <div class="top-margin-20" v-if="reco_data.toggle_more_info && reco_data.close_reco && reco_data.close_reco.length">
          <div class="faded-border-bottom">&nbsp;</div>

          <div class="label-md-bold-black top-margin-10">Previous recommendations</div>

          <div v-for="(item, itemIndex) in reco_data.close_reco" :key="itemIndex">
            <el-row :gutter="20" class="top-margin-20">
              <el-col :xs="24" :sm="24" :md="24" :lg="24" :xl="24">

                <div style="margin: 2px 0;" v-if="itemIndex == reco_data.close_reco.length - 1">
                  <div class="label-xs-bold" style="font-size: 12px;">Original reco date : {{ item.created_at | close_reco_date_filter }}</div>
                </div>

                <div style="margin: 2px 0;" v-if="itemIndex < reco_data.close_reco.length - 1">
                  <div class="label-xs-bold" style="font-size: 12px;">Updated on : {{ item.closed_date_time | close_reco_date_filter }}</div>
                </div>

                <div class="reco-more-details-container isDeskTopView" style="border-right: 8px solid #d60918;">

                  <div class="vertical-flex">
                    <label class="input-label-gray">RECO</label>
                    <span
                      class="label-xs-bold uppercase"
                      :style="[ (item.reco == 'Buy' ) ? {'color': '#079e3e'} : ( item.reco == 'Sell' ) ? {'color': '#d60918'} : {'color': '#e2ba00'} ]"
                    >{{ item.reco }}</span>
                  </div>

                  <div>
                    <!-- <div v-if="itemIndex == 0"> -->
                    <div>
                      <label class="input-label-gray">Reco Date</label>
                      <div class="label-xs-bold">{{ item.created_at | formatDate }}</div>
                    </div>

                    <!-- <div v-if="itemIndex > 0">
                      <label class="input-label-gray">Reco Date</label>
                      <div class="label-xs-bold">{{ item.closed_date_time | formatDate }}</div>
                    </div> -->

                    <div class="top-margin-10">
                      <label class="input-label-gray">Reco Price</label>
                      <div class="label-xs-bold">₹ {{ item.reco_open_price }}</div>
                    </div>
                  </div>

                  <div class="vertical-flex">
                    <label class="input-label-gray">Performance</label>
                    <span
                      class="label-lg-bold"
                      :style="[ (( item.reco_status == 'CLOSED' ) && item.performance > 0) ? {'color': '#079e3e'} : ( item.reco_status == 'CLOSED' ) && item.performance < 0 ? {'color': '#d60918'} : {'color': '#a29eab'} ]"
                    >{{ !item.performance ? 0 : item.performance }}%</span>
                  </div>

                  <div>
                    <div>
                      <label class="input-label-gray">Last Tracked Date</label>
                      <div class="label-xs-bold">{{ item.closed_date_time | formatDate }}
                      </div>
                    </div>
                    <div class="top-margin-10">
                      <label class="input-label-gray">Last Tracked Price</label>
                      <div class="label-xs-bold">₹ {{ item.reco_status == 'CLOSED' ? item.closed_price :
                        item.reco_status == 'TARGET ACHIEVED' ? item.target_achieved_price : item.reco_status == 'TARGET NOT ACHIEVED' ? item.target_not_achieved_price : item.reco_status == 'STOP LOSS TRIGGERED' ? item.stop_loss_triggered_price : item.stock.current_price }}
                      </div>
                    </div>
                  </div>

                  <div class="vertical-flex">
                    <label class="input-label-gray">
                      Potential
                    </label>
                    <div class="label-lg-bold" style="color: #979797;">{{ !item.potential_as_of_cdate ? 0 : item.potential_as_of_cdate }}%</div>
                  </div>

                  <div>
                    <div>
                      <label class="input-label-gray">Target Period</label>
                      <div class="label-xs-bold">{{ item.target_period }}</div>
                    </div>

                    <div class="top-margin-10">
                      <label class="input-label-gray">Target Price</label>
                      <div class="label-xs-bold">
                        ₹ {{ item.target_price }}
                        <span class="input-label-gray" style="font-size: 11px;">({{ item.target_potential }}%)</span>
                      </div>
                    </div>
                  </div>

                  <div class="vertical-flex">
                    <label class="input-label-gray">
                      STATUS
                    </label>
                    <div class="label-xs-bold" style="color: #d60918;">CLOSED</div>
                  </div>
                </div>

                <!-- mobile view previous close recos -->
                <div class="isMobileView" style="margin-top: 0px; padding: 8px; border: 1px solid #ddd; border-radius: 18px; border-right: 6px solid #d60918;">

                  <div class="flex-center">
                    <label class="input-label-gray">RECO - </label> &nbsp;
                    <span
                      class="label-xs-bold uppercase"
                      :style="[ (item.reco == 'Buy' ) ? {'color': '#079e3e'} : ( item.reco == 'Sell' ) ? {'color': '#d60918'} : {'color': '#e2ba00'} ]"
                    >{{ item.reco }}</span>
                  </div>

                  <div style="display: flex; justify-content: space-around;" class="top-margin-10">

                    <div class="col1" style="display: flex;">
                      <div class="row1">
                        <div v-if="itemIndex == 0">
                          <label class="input-label-gray">Reco Date</label>
                          <div class="label-xs-bold">{{ item.created_at | formatDate }}</div>
                        </div>

                        <div v-if="itemIndex > 0">
                          <label class="input-label-gray">Reco Date</label>
                          <div class="label-xs-bold">{{ item.closed_date_time | formatDate }}</div>
                        </div>

                        <div>
                          <label class="input-label-gray">Last Tracked Date</label>
                          <div class="bottom-margin-10 label-xs-bold">{{ item.closed_date_time | formatDate }}
                          </div>
                        </div>

                        <div>
                          <label class="input-label-gray">Target Period</label>
                          <div class="bottom-margin-10 label-xs-bold">{{ item.target_period }}</div>
                        </div>
                      </div>
                    </div>

                    <div class="col2">
                      <div class="row2">
                        <div>
                          <label class="input-label-gray">
                            Reco Price
                          </label>
                          <div class="bottom-margin-10 label-xs-bold">₹ {{ item.reco_open_price }}</div>
                        </div>

                          <div>
                            <label class="input-label-gray">Last Tracked Price</label>
                            <div class="bottom-margin-10 label-xs-bold">
                              ₹ {{item.reco_status == 'CLOSED' ? item.closed_price :
                              item.reco_status == 'TARGET ACHIEVED' ? item.target_achieved_price : item.reco_status == 'TARGET NOT ACHIEVED' ? item.target_not_achieved_price : item.reco_status == 'STOP LOSS TRIGGERED' ? item.stop_loss_triggered_price : item.stock.current_price }}
                            </div>
                          </div>

                          <div>
                            <label class="input-label-gray">Target Price</label>
                            <div class="bottom-margin-10 label-xs-bold">
                              ₹ {{ item.target_price }}
                              <span class="input-label-gray" style="font-size: 11px;">({{ item.target_potential }}%)</span>
                            </div>
                          </div>
                      </div>
                    </div>

                    <div class="col3 vertical-flex">
                      <label class="input-label-gray">
                        Performance
                      </label>
                      <div
                        class="label-lg-bold"
                        :style="[ (( item.reco_status == 'CLOSED' ) && item.performance > 0) ? {'color': '#079e3e'} : ( item.reco_status == 'CLOSED' ) && item.performance < 0 ? {'color': '#d60918'} : {'color': '#a29eab'} ]"
                      >{{ !item.performance ? 0 : item.performance }}%</div>

                        <!-- :style="[ reco_data.performance >= 0 ? { color: '#079e3e' } : { color: '#d60918' } ]" -->
                      <label class="input-label-gray">
                        Potential
                      </label>
                      <div class="label-lg-bold" style="color: #979797;">{{ item.potential_as_of_cdate ==null ? 0 : item.potential_as_of_cdate }}%
                      </div>

                      <label class="input-label-gray">
                        STATUS
                      </label>
                      <div class="label-xs-bold" style="color: #d60918;">CLOSED</div>
                    </div>
                  </div>
                </div>
              </el-col>
            </el-row>
            <div class="relative" v-if="itemIndex < reco_data.close_reco.length - 1">
              <!-- <div class="vl"></div> -->
              <img src="../assets/images/company/arrow.svg" class="vl">
            </div>
          </div>
        </div>

      </el-col>
    </el-row>
  </div>
</template>

<script>
import { serverAddr, serverHostName } from "../networkConfig";
import NewCircleProgress from "./NewCircularProgress";
import Countdown from 'vuejs-countdown';
import { filterCallBack } from "../mixins/filter";
import { EventBus } from "../eventBus";
import Timer  from "./Timer";
import { filter } from 'minimatch';

export default {
  name: "ComparedRecommendationsOfExpert",

  props: ["expertsRecommendationsList", "parentIndex"],

  mixins: [filterCallBack],

  components: {
    Countdown,
    NewCircleProgress,
    Timer
  },

  data(){
    return{
      isExpertListLoading: false,
      serverHostName: serverHostName
    }
  },

  methods: {
    getPerformanceWheelValue(reco_data){
      if(reco_data.performance == null || reco_data.performance == ''){
        return String(0);
      }else if(reco_data.reco_status == 'TARGET ACHIEVED'){
        return String(100);
      }else if(reco_data.performance < 0){
        return  String(reco_data.performance);
      }

      let v = String(((reco_data.performance / reco_data.target_potential)*100).toFixed(2));
      if (v > 100){
        return 100;
      }

      return v;
    },

    // if compared expert is logged in user then restricted him to go on accuracy page
    goToOtherExpertAccuracyPage(reco){
      if(this.userProfile.id != reco.user.user_profile_id){
        if(this.recoType == 'shortTerm'){
          let routeData = this.$router.resolve({
            name : 'otherExpertShortTermAccuracyGraph', params: { stockId : reco.stock.Id, expertId : reco.user.user_profile_id, createdDate : reco.created_at, resultDate : reco.result_date_time, duration : reco.duration }
          })
          window.open(routeData.href, "_blank");
        }else{
          let routeData = this.$router.resolve({
            name : 'otherExpertLongTermAccuracyGraph', params: { stockId : reco.stock.Id, expertId : reco.user.user_profile_id, createdDate : reco.created_at, resultDate : reco.result_date_time, duration : reco.duration }
          })
          window.open(routeData.href, "_blank");
        }
      }
    },

    getRecoByStockName(reco){
      this.$emit('getRecoByStockNameFromChild', reco);
    },

    getRecoByExpert(reco){
      this.$emit('getRecoByExpertFromChild', reco);
      EventBus.$emit("selectedStock", '');      //to clear selected market expert on filter : mobile dialog and desktop
    },

    //remove reco from list
    removeFromList(index) {
      this.expertsRecommendationsList.splice(index, 1);
      EventBus.$emit('removedComparedExpertFromList', this.parentIndex);
    },

    // toogle more information
    toggleMoreInfo(index){
      this.expertsRecommendationsList[index].toggle_more_info = !this.expertsRecommendationsList[index].toggle_more_info
    },

    //go to antestimate link
    goToAntestimateLink(item) {
      // passed stock_id and user_id
      let routeData = this.$router.resolve({
        name: "unlockedAntEstimate",
        params: { reco_id: item.id, user_id: item.user.user_profile_id, stock_id: item.stock.Id, duration: item.duration }
      });
      window.open(routeData.href, "_blank");
    },
  },
  computed: {
    userProfile() {
      return JSON.parse(localStorage.getItem("profile"));
    },
  },

  beforeDestroy() {
    EventBus.$off();
  },
};
</script>
<style lang="scss" scoped>

.reco-section{
  /* text-align: center; */
  display: flex;
  justify-content: center;
}
.reco-btns{
  max-width: 50px;
  margin: 0 0 10px 0!important;
  display: block;
}
.reco-details{
  padding-bottom: 20px;
}
.target-period-section{
  display: flex!important;
  justify-content: center;
  border-right: 1px solid #ddd;
}
.target-period-details{
  display: block;
}
.performance-section{
  display: flex;
  justify-content: center;
  padding: 0 10px;
  border-right: 1px solid #ddd;
}
.progress-description{
  padding-left: 25px;
}
.progress-bar-legends{
  width: 12px;
  height: 12px;
  background-color: #a29eab;
  border-radius: 3px;
  margin: 0 10px 0 0;
}
.legends-text{
  font-size: 0.8rem;
  margin-right: 5px;
}
.accuracy-section{
  text-align: center;
  display: flex;
  flex-direction: column;
  // padding: 0!important;
}
.antestimate-block{
  text-align: center;
  border-radius: 20px;
  border: 1px solid #333;
  font-size: 0.8rem;
  font-weight: 500;
  color: #000;
  padding: 5px 10px;
  width: fit-content;
  margin: 5px auto;
}
.faded-border-bottom{
  display: block;
  border: none;
  color: #fff;
  height: 1px;
  background: -webkit-gradient(radial, 50% 50%, 0, 50% 50%, 450, from(#ddd), to(#fff));
}
.ComparedRecommendationsOfExpert .timer {
  align-self: center;
}
.ComparedRecommendationsOfExpert .cross-icon {
  color: #ddd;
  font-size: 20px;
}
.ComparedRecommendationsOfExpert .cross-icon:hover {
  font-size: 20px;
  color: black;
  cursor: pointer;
}
.ComparedRecommendationsOfExpert .border-bottom-gray {
  border-bottom: 1px solid #ddd;
  padding-bottom: 10px;
}
.ComparedRecommendationsOfExpert .user-profile-pic {
  height: 38px;
  width: 38px;
  border-radius: 50px;
  margin-right: 10px;
  object-fit: cover;
}
.ComparedRecommendationsOfExpert .bottom-margin-10 {
  margin-bottom: 8px;
}
.ComparedRecommendationsOfExpert .flex-column {
  display: flex;
  flex-direction: column;
  margin-top: 8px;
}
.ComparedRecommendationsOfExpert .reco-more-details-container {
  display: flex;
  justify-content: space-around;
  padding: 8px;
  border: 1px solid #ddd;
  border-radius: 18px;
}

.ComparedRecommendationsOfExpert .active-period-type-tag:focus,
.ComparedRecommendationsOfExpert .period-type-tag:focus {
  outline: none;
}

.ComparedRecommendationsOfExpert .vertical-flex {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
}
.ComparedRecommendationsOfExpert .info-Logo {
  height: 9px;
  padding: 0px 2px 0px 3px;
}
.expertPerformanceListSection {
  border-top: 1px dashed #ddd;
  padding: 5px 0 0;
  margin-top: 10px;
}

//media queries
@media screen and (max-width: 1200px) {
  .reco-section{
    display: block;
    margin: 10px 0 0 0;
  }
  .reco-btn-section{
    display: flex;
  }
  .reco-btn-section .reco-btns{
    margin: 0 10px 0 0!important;
  }
  .target-period-section{
    margin: 20px 0 0 0;
    display: flex!important;
    justify-content: space-between;
    border-right: none;
  }
  .target-period-details{
    display: flex;
    justify-content: space-between;
    width: 100%;
    /* border-bottom: 1px solid #ddd; */
    padding-bottom: 10px;
  }
  .period-contents{
    padding: 0 20px 0 0;
  }
  .performance-section{
    display: block;
    text-align: center;
  }
  .progress-description{
    padding: 0;
  }
  .progress-bar-legends-section{
    display: flex;
    justify-content: center;
    text-align: center;
  }
}
@media screen and (min-width: 993px) {
  .ComparedRecommendationsOfExpert .isMobileView {
    display: none;
  }
  .target-period-section-border{
    display: none;
  }
}
@media screen and (max-width: 992px) {
  .ComparedRecommendationsOfExpert .isDeskTopView {
    display: none;
  }
  .ComparedRecommendationsOfExpert .isMobileView {
    margin-top: 30px;
  }
  .performance-accuracy-container{
    margin-top: 20px;
  }
}
@media screen and (max-width: 575px) {
  .period-contents{
    padding: 0 0px 0 0;
  }
  .performance-section{
    padding: 0 5px;
  }
  .progress-bar-legends-section{
    display: block;
  }
  .accuracy-section{
    padding: 0 5px!important;
  }
  .faded-border-bottom{
    display:block;
    border:none;
    color:#fff;
    height:1px;
    background: -webkit-gradient(radial, 50% 50%, 0, 50% 50%, 250, from(#ddd), to(#fff));
  }
}
</style>
<style lang="scss">
@import "../css/variable.scss";
@import "../css/common.scss";

.ComparedRecommendationsOfExpert .box-card {
  border-radius: 10px!important;
  border: none;
  box-shadow: none;
}
.ComparedRecommendationsOfExpert .employee-select-box .el-input--mini .el-input__inner{
  height: 25px;
  border-radius: 8px;
}
.el-select-dropdown__list li{
  font-size: 12px;
}
.el-select-dropdown__item:hover {
  color: $primary-theme-color !important;
  background-color: #f5f7fa !important;
}
.el-select-dropdown__item.selected {
  color: $primary-theme-color;
}
.ComparedRecommendationsOfExpert .el-progress-bar {
  padding: 0;
}
.ComparedRecommendationsOfExpert .el-progress__text {
  display: none;
}
.ComparedRecommendationsOfExpert  .vuejs-countdown .digit {
  font-size: 28px;
}
.ComparedRecommendationsOfExpert .el-checkbox__inner{
  border-radius: 4px;
}
</style>
